<script context="module" lang="ts">
    export type QuickFilterType = {
        text: string;
        filter: any;
        showCount: boolean|undefined,
        updateFilter: boolean|undefined,
        class: string|((c:number)=>string)|undefined,
        active: boolean
    };
</script>

<script lang="ts">
    import { jobs } from "../../stores/store";
    import IconCheck from "./Icons/IconCheck.svelte";
    import WhiteColor from "./WhiteColor.svelte";
    import Checkbox from "./Checkbox/Checkbox.svelte";
    import type { ModeType } from "./Checkbox/types";

    export let quickFilter: QuickFilterType;
    export let index: number;
    export let onSwitch: (index: number, active: boolean) => void = (index: number, active: boolean) => {};

    let _class: string = '';
    let _checkboxMode: ModeType = 'black-checkbox';
    $: {
        if (typeof(quickFilter.class) == 'function') {
            _class = quickFilter.class($jobs.quickFilters.counts[index]?.count || 0);
        } else {
            _class = quickFilter.class || '';
        }
        _checkboxMode = _class == 'error' ? 'white-checkbox' : 'black-checkbox';
        console.log('quickFilter, ', quickFilter.text, _class, _checkboxMode);
    }

    function onClick() {
        quickFilter.active = !quickFilter.active;
        onSwitch(index, quickFilter.active);
    }
</script>

<div class="quick-filter {_class} {quickFilter.active ? 'active' : ''}" on:click={onClick}>
    <Checkbox label="" checked={quickFilter.active} mode={_checkboxMode}/>
    {quickFilter.text}
    {#if quickFilter.showCount && $jobs.quickFilters.counts[index]}
        ({$jobs.quickFilters.counts[index]?.count})
    {/if}
</div>

<style>
    .quick-filter {
        display: flex;
        align-items: center;
        gap: 4px;
        border-radius: 15px;
        padding: 1px 10px 1px 10px;
        cursor: pointer;
        height: 27px;
        line-height: 27px;
        background-color: #f2f2f2;
        font-size: 14px;
        white-space: nowrap;
    }
    .quick-filter:hover {
        background-color: #6c6b6a;
        color: white;
        transition: 0.1s;
    }
    .quick-filter.error {
        background-color: var(--automapa-red);
        color: #fff;
    }
</style>